import Tabs from '../../../components/v2/ui/Tabs/Tabs';
import { TabItem } from '../../../components/v2/ui/Tabs/tabs.types';

interface ResultsTabsProps {
  tabs: TabItem[];
  activeTabId: string;
  onSelect: (id: string) => void;
}

function ResultsTabs({ tabs, activeTabId, onSelect }: ResultsTabsProps) {
  if (tabs.length === 0) {
    return null;
  }

  return <Tabs items={tabs} selectedId={activeTabId} onSelect={onSelect} />;
}

export default ResultsTabs;
